import apiDB from './api_db';

let race_history = new apiDB({
    api_module: 'race_history',
    table_key_name: 'id',
    reducer_name: 'raceR',
    reducer_var: 'history_events',
    action_prefix: 'RACE_HISTORY_EVENT'});

export default race_history;